import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/auth/authContext';
import { ConfirmProvider } from '@/components/confirmDialog/confirmContext';
import { UnsavedProvider } from '@/components/confirmDialog/unsavedContext';
import App from './App';
import '@/styles/global.scss';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UnsavedProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </UnsavedProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
